import { useState,useRef,useEffect } from 'react';
import styles from './ModelAdd.module.css';
import EmptyModal from '../../compoenets/EmptyModal'
import useApi from '../../services/useApi';

const AddedItem=({item,onClick,onChange})=>{
    const [isModify,setIsModify]=useState(false);
    const [inputValue,setInputValue]=useState(item.modelName);

    const handleModify=()=>{
        if(isModify)onChange(item,inputValue);
        setIsModify(!isModify);
    }
    return(
        <div className={styles['round-item']}>
            {!isModify?
            <p>
                <span>{item.modelName}</span>
                <span>acc {item.trainingResult.outputs.loss}</span>
                {/* <span>Task {item.taskId.split('-')[0]}</span> */}
            </p>
            :
            <input 
            value={inputValue}
            onChange={(e)=>setInputValue(e.target.value)}
            />
            }
            <div className={`${styles['property']} ${isModify&&styles['property-modify']}`}>
                <button onClick={handleModify}/>
                <button onClick={()=>isModify?setIsModify(false):onClick()}/>
            </div>
        </div>
    )
}

const RoundItem=({item,onClick})=>{
    return(
        <div className={styles['round-item']}>
            <p>
                <span>{item.roundNum + ' Round'}</span>
                <span>acc {item.trainingResult.outputs.loss}</span>
            </p>
            <button onClick={onClick}>Add</button>
        </div>
    )
}

export default function ModelAdd({onChange,onClose}){
    const inputRef=useRef(null);
    const [uploadErr,setUploadErr] = useState(false);
    const [uploadMsg,setUploadMsg]=useState("");
    const nameRef=useRef(null);
    const [inputValue,setInputValue]=useState(null);
    const [roundData,setRoundData]=useState([])
    const [addedData,setAddedData]=useState([])

    const handleChangeRound=(item)=>{
        setAddedData(prev=>[...prev,{
            "modelName" : "Name"+item.taskName+"-ID"+item.taskId.split('-')[0]+"-RN"+item.roundNum,
            "userId" : JSON.parse(localStorage.getItem("account")).id,
            ...item
        }])
        setRoundData(prev => prev.filter( prevItem => prevItem.roundId !== item.roundId));
    }

    const handleChangeAdded=(item)=>{
        setAddedData(prev => prev.filter( prevItem => prevItem.roundId !== item.roundId));
        setRoundData(prev=>[...prev,{
            "modelName" : "Name"+item.taskName+"-ID"+item.taskId.split('-')[0]+"-RN"+item.roundNum,
            "userId" : JSON.parse(localStorage.getItem("account")).id,
            ...item
        }])
    }

    const handleRenameAdded=(item,name)=>{
        setAddedData(prev=>
            prev.map(prevItem=>
                (prevItem.taskId===item.taskId&&prevItem.roundNum===item.roundNum)
                ?
                {...prevItem,modelName:name}
                :
                prevItem
            )
        )
    }

    const handleUpload = async () => {
        useApi.post('backboard/model/playground/import',addedData).then((res)=>{
          setUploadMsg("Success");
          onChange();
          onClose();
        })
        .catch(async (err) => {
        });
    };

    useEffect(()=>{
        if(!inputRef.current)return;
        inputRef.current.focus();

        const handleInputKeyDown=(e)=>{
            if(e.key ==='Escape'){
                onClose();
            }
        }

        document.addEventListener("keydown", handleInputKeyDown);
        return () => {
          document.removeEventListener("keydown", handleInputKeyDown);
        };
    },[])

    const handleClear=()=>{
        useApi.get('backboard/model/playground/flcore/'+inputValue+'/rounds').then((res)=>{
            setRoundData(res.data.data);
            setAddedData([])
        }).catch(function (thrown) {
        });
    }

    useEffect(()=>{
        if(inputValue===null||inputValue==='')return;

        useApi.get('backboard/model/playground/flcore/'+inputValue+'/rounds').then((res)=>{
            setRoundData(res.data.data);
        }).catch(function (thrown) {
        });

    },[inputValue])

    const handleInputChange=(event)=>{
        setInputValue(event.target.value);
    }

    useEffect(()=>{
        let timer;
        if(uploadErr){
            timer=setTimeout(() => {
                setUploadErr(false);
            }, 1200);
        }
        return()=>{
            clearTimeout(timer);
        }
    },[uploadErr])
    
    return(
        <EmptyModal onClose={()=>onClose()}>
            <div className={styles['wrap']}>
                <header>
                    <span>Add round model</span>
                    <button
                    className={`
                    ${styles['header-btn']} 
                    ${uploadMsg.includes('Success')&&styles['header-btn-success']}
                    ${uploadMsg.includes('Fail')&&styles['header-btn-fail']}
                    `}
                    onClick={onClose}
                    />
                </header>
                <div className={styles['body']}>
                    <input 
                    ref={inputRef}
                    placeholder='Task ID를 입력해 주세요.'
                    value={inputValue}
                    onChange={handleInputChange} 
                    />
                    <div className={styles['list']}>
                        <div className={styles['list-round']}>
                            {roundData?.map(item=>(
                                <RoundItem item={item} onClick={()=>handleChangeRound(item)}/>
                            ))}
                        </div>
                        <div className={styles['list-added']}>
                            {addedData?.map(item=>(
                                <AddedItem 
                                item={item} 
                                onClick={()=>handleChangeAdded(item)}
                                onChange={handleRenameAdded}
                                />
                            ))}
                        </div>
                    </div>
                </div>
                <footer>
                    <button 
                    className={styles["btn-clear"]} 
                    onClick={handleClear}/>
                    <button className={`
                      ${styles["btn-upload"]} 
                      ${uploadErr&&styles['btn-upload-err']}`
                      } 
                      onClick={handleUpload}
                    />
                </footer>
            </div>
        </EmptyModal>
    )
}